export default __webpack_public_path__ + "static/media/timer.a3c23019.svg";